import { render } from "./TailFile.vue?vue&type=template&id=0846b738&scoped=true"
import script from "./TailFile.vue?vue&type=script&lang=js"
export * from "./TailFile.vue?vue&type=script&lang=js"

import "./TailFile.vue?vue&type=style&index=0&id=0846b738&lang=css&scoped=true"
/* custom blocks */
import block0 from "./TailFile.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/Users/shaohuanqing/dev/kuboard-spray/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0846b738"]])

export default __exports__